import { styled } from '@volkswagen-onehub/components-core';

export const StyledMark = styled.span(
  ({ theme }) => `
  mark {
    background-color: ${theme.colors.accent.offer.default};
    border-radius: 0.25rem;
    padding: 0.125rem 0;
  }
`
);
